import {searchModel} from "../../../../Utilities/Search";

export const loanLibraryLoanSearchModel = (pageId = "", userId = "", shippingLocationId = "", dueDate = "", checkoutDate = "", loanLibraryLoanStatus = "", isOverdue: string | null = null, districtId = "", organization = "", searchKeyword = "") => {
    return Object.assign({}, searchModel(pageId.toString(), "shippingLocationName", false, "shippingLocationName"), {
        userId,
        shippingLocationId,
        dueDate,
        checkoutDate,
        loanLibraryLoanStatus,
        isOverdue,
        districtId,
        organization,
        searchKeyword,
        ClearLoanLibraryLoanSearch: clearLoanLibraryLoanSearch,
        Search: search,
    });
};

function clearLoanLibraryLoanSearch(this: Record<string, unknown>) {
    this.userId = "";
    this.shippingLocationId = "";
    this.dueDate = "";
    this.checkoutDate = "";
    this.loanLibraryLoanStatus = "";
    this.isOverdue = null;
    this.districtId = "";
    this.organization = "";
    this.searchKeyword = "";
    (this as { ClearSearch: (load: boolean) => void }).ClearSearch(false);
}

function search(this: Record<string, any>, criteria: Record<string, any>) {
    this.userId = criteria.userId || "";
    this.shippingLocationId = criteria.shippingLocationId || "";
    this.dueDate = criteria.dueDate || "";
    this.checkoutDate = criteria.checkoutDate || "";
    this.loanLibraryLoanStatus = criteria.loanLibraryLoanStatus || "";
    this.isOverdue = criteria.isOverdue;
    this.districtId = criteria.districtId || "";
    this.organization = criteria.organization || "";
    this.searchKeyword = criteria.searchKeyword || "";
}


